import type { IDisplaySection } from "@lexicanon/shared"
import { useProduct } from "../../../lib/tenant"
import { EditableAnalysisField } from "../../EditableAnalysisField"
import type { IEditContext } from "../interfaces"
import styles from "./LexSection.module.css"
import { SectionHeader } from "./SectionHeader"

interface IProps {
  section: IDisplaySection
  data: unknown
  editContext?: IEditContext
}

export function TextSection({ section, data, editContext }: IProps): React.ReactElement | null {
  const product = useProduct()
  if (!data) return null
  const text = typeof data === "string" ? data : JSON.stringify(data)

  const fieldPath = section.dataPath
  const isEdited = !!editContext?.fieldEdits[fieldPath]

  const content =
    editContext && typeof data === "string" ? (
      <EditableAnalysisField
        meetingId={editContext.meetingId}
        fieldPath={fieldPath}
        value={text}
        canEdit={editContext.canEdit}
        isEdited={isEdited}
        onSaved={editContext.onEdited}
      />
    ) : product === "lexicanon" ? (
      <div className={styles.textCard}>{text}</div>
    ) : (
      <p style={{ margin: 0, fontSize: "var(--mantine-font-size-sm)", lineHeight: 1.65 }}>{text}</p>
    )

  if (editContext && typeof data === "string") {
    return (
      <div>
        <SectionHeader id={section.id} label={section.label} />
        <div className={styles.textCard}>{content}</div>
      </div>
    )
  }

  return (
    <div>
      <SectionHeader id={section.id} label={section.label} />
      {content}
    </div>
  )
}
